export const REDUX_STORE_HOME = 'chat-replay'
export const DEFAULT_PAGE_SIZE = 25
export const MAX_PAGE_SIZE = 200
